// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-module--container--2Vuxu"};